import { render, staticRenderFns } from "./Sac.vue?vue&type=template&id=4647e3b0"
import script from "./Sac.vue?vue&type=script&lang=js"
export * from "./Sac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports